import { render, staticRenderFns } from "./FontStyle.vue?vue&type=template&id=21016200"
import script from "./FontStyle.vue?vue&type=script&lang=js"
export * from "./FontStyle.vue?vue&type=script&lang=js"
import style0 from "./FontStyle.vue?vue&type=style&index=0&id=21016200&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports